<template>
  <div class="products">
    <h1>Report Prezzi Migliori</h1>
    <div class="table-wrap">
        <div>
            <nav aria-label="Pagine">
              <ul class="pagination">
                <li class="page-item">
                  <a class="page-link" href="#" @click="gotoPage(0)">Prima</a>
                </li>
                <li class="page-item" v-show="page>1"><a class="page-link" href="#" @click="gotoPage(page-2)">{{page-1}}</a></li>
                <li class="page-item" v-show="page>0"><a class="page-link" href="#" @click="gotoPage(page-1)">{{page}}</a></li>
                <li class="page-item active" aria-current="page">
                  <span class="page-link">
                    {{page+1}}
                    <span class="sr-only">(current)</span>
                  </span>
                </li>
                <li class="page-item" v-show="page<Math.ceil(count/20)-1"><a class="page-link" href="#" @click="gotoPage(page+1)">{{page+2}}</a></li>
                <li class="page-item" v-show="page<Math.ceil(count/20)-2"><a class="page-link" href="#" @click="gotoPage(page+2)">{{page+3}}</a></li>
                <li class="page-item">
                  <a class="page-link" href="#" @click="gotoPage(Math.ceil(count/20)-1)">Ultima</a>
                </li>
              </ul>
            </nav>
        </div>
        <div class="table-responsive">
          <table>
            <tr>
              <td width="">FID</td>
              <td width="">EAN</td>
              <td width="">Prodotto</td>
              <td width="">Nostro Prezzo</td>
              <td width="">Miglior prezzo</td>
              <td width="">Sito</td>
              <td width="">Delta</td>
              <td width="200" align="center">Azioni</td>
            </tr>
            <tr>
              <td width=""><input type="text" placeholder="fid" v-model="filters.sku"></td>
              <td width=""><input type="text" placeholder="ean" v-model="filters.ean"></td>
              <td width=""><input type="text" placeholder="nome" v-model="filters.name"></td>
              <td width=""></td>
              <td width=""></td>
              <td width=""></td>
              <td width=""></td>
              <td width="200" align="center">
                  <button class="src_btn" @click="getProducts">Cerca</button>
              </td>
            </tr>
            <tr v-for="product in products" v-bind:key="product" v-if="products && products.length > 0">
              <td>{{ product.sku }}</td>
              <td>{{ product.ean }}</td>
              <td>{{ product.name }}</td>
              <td>{{ product.our_price.toFixed(2) }}</td>
              <td>{{ product.their_price.toFixed(2) }}</td>
              <td>{{ product.their_website }}</td>
              <td>{{ product.delta.toFixed(2) }}</td>
              <td align="center">
                  <router-link v-bind:to="{ name: 'ReportProductSku', params: { sku: product.sku } }">Grafico</router-link>
                  <br>
                  <router-link v-bind:to="{ name: 'ReportProductTable', params: { sku: product.sku } }">Tabella</router-link>
                  <br>
                  <router-link v-bind:to="{ name: 'ReportProductDate', params: { sku: product.sku } }">Sito</router-link>
              </td>
            </tr>
            <tr v-else>
              <td colspan="5"> Nessun prodotto corrispondente ai criteri di ricerca!</td>
            </tr>
          </table>
      </div>
      <div>
          <nav aria-label="Pagine">
            <ul class="pagination">
              <li class="page-item">
                <a class="page-link" href="#" @click="gotoPage(0)">Prima</a>
              </li>
              <li class="page-item" v-show="page>1"><a class="page-link" href="#" @click="gotoPage(page-2)">{{page-1}}</a></li>
              <li class="page-item" v-show="page>0"><a class="page-link" href="#" @click="gotoPage(page-1)">{{page}}</a></li>
              <li class="page-item active" aria-current="page">
                <span class="page-link">
                  {{page+1}}
                  <span class="sr-only">(current)</span>
                </span>
              </li>
              <li class="page-item" v-show="page<Math.ceil(count/20)-1"><a class="page-link" href="#" @click="gotoPage(page+1)">{{page+2}}</a></li>
              <li class="page-item" v-show="page<Math.ceil(count/20)-2"><a class="page-link" href="#" @click="gotoPage(page+2)">{{page+3}}</a></li>
              <li class="page-item">
                <a class="page-link" href="#" @click="gotoPage(Math.ceil(count/20)-1)">Ultima</a>
              </li>
            </ul>
          </nav>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsService from '@/services/ReportsService'
export default {
  name: 'ReportProducts',
  data () {
    return {
      page: 0,
      count: 0,
      filters: [],
      products: []
    }
  },
  mounted () {
    this.getProducts()
  },
  methods: {
    gotoPage (page) {
        this.page = page
        this.getProducts()
    },
    async getProducts () {
      // console.log(this.filters.sku)
      const response = await ReportsService.low({sku: this.filters.sku, ean: this.filters.ean, name: this.filters.name, page: this.page})
      this.products = response.data.report
      this.count = response.data.count
      // console.log(this.products)
    },
    formatDate (value) {
        if (!value) {
            return ''
        }
        var date = new Date(value)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }
  }
}
</script>
<style type="text/css">
.table-wrap {
  /*width: 80%;
  margin: 0 auto;*/
  text-align: center;
}
table {
  /*width: 100%;*/
}
table th, table tr {
  text-align: left;
}
table thead {
  background: #f2f2f2;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #4d7ef7;
  color: #fff;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
.src_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: auto!important;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportPricesLow.vue